var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.665C11.6904 17.665 12.25 17.1054 12.25 16.415C12.25 15.7247 11.6904 15.165 11 15.165C10.3096 15.165 9.75 15.7247 9.75 16.415C9.75 17.1054 10.3096 17.665 11 17.665Z",
    fill: "#4E4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0016 12.6667V11.8333C11.5785 11.8333 12.1424 11.6623 12.622 11.3418C13.1017 11.0213 13.4755 10.5658 13.6963 10.0328C13.917 9.49988 13.9748 8.91343 13.8623 8.34765C13.7497 7.78188 13.4719 7.26218 13.064 6.85427C12.6561 6.44637 12.1364 6.16858 11.5706 6.05604C11.0049 5.9435 10.4184 6.00126 9.88547 6.22202C9.35252 6.44277 8.897 6.81661 8.57651 7.29625C8.25602 7.7759 8.08496 8.33981 8.08496 8.91667",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.cfa9c6fd44c195d05fd2f0bc689e926d.svg";
export { ForwardRef as ReactComponent };